import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

const Disclaimer = ({ children }: Props) => {
  return (
    <div className="bg-white pt-32">
      <div className="container">
        <div className="row">
          <div className="col-span-9 col-start-2 space-y-16 text-center xs:col-span-8 xs:col-start-3">{children}</div>
        </div>
      </div>
    </div>
  );
};
export default Disclaimer;
